import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const putProductType = (
    token: string,
    backend: string,
    changed_by_id: string,
    name: string,
    description: string,
    id: number,
) => {
    return fetch(
        `${getApiUrl(backend)}producttypes/${id}`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                changed_by_id,
                name,
                description,
            })
        }
    );
};

export default putProductType